import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const triggers = new Map();

const returnFocus = (id) => {
  const trigger = triggers.get(id);

  if (trigger) {
    trigger.focus();
    triggers.delete(id);
  }
};

const handleEscKeyClose = (store, dialog) => {
  dialog.addEventListener('close', () => {
    enableBodyScroll(dialog);
    returnFocus(dialog.id);
    store.openDialogs.delete(dialog.id);
  }, { once: true });
};

export const dialog = {
  openDialogs: new Set(),

  isOpen(id) {
    return this.openDialogs.has(id);
  },

  open(id) {
    const dialog = document.getElementById(id);

    if (!dialog) return;

    triggers.set(id, document.activeElement);
    handleEscKeyClose(this, dialog);
    dialog.showModal();
    disableBodyScroll(dialog);
    this.openDialogs.add(id);
  },

  close(id) {
    const dialog = document.getElementById(id);

    if (!dialog) return;

    dialog.close();
    enableBodyScroll(dialog);
    returnFocus(id);
    this.openDialogs.delete(id);
  },

  closeAll() {
    const openDialogs = document.querySelectorAll('dialog[open]');

    for (const d of openDialogs) {
      this.close(d.id);
    }
  },

  toggle(id) {
    const dialog = document.getElementById(id);

    if (!dialog) return;

    if (dialog.open) {
      this.close(id);
      return;
    }

    this.closeAll();
    this.open(id);
  },

  handleClickOutside(event, id) {
    const dialog = document.getElementById(id);

    if (!dialog) return;

    const rect = dialog.getBoundingClientRect();

    if (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    ) {
      this.close(id);
    }
  },
};
